import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { IEvent, PaymentBusEventsService } from '../../services/payment.busevents.service';
import { UICardContainerComponent } from "../../../../shared/ui-commons/ui-card-page/ui-card-page.components";
import { LocationAssetsPipe } from "@utils/pipes/location-assets.pipe";
import { NewRelicService } from '../../services/newRelic.service';

@Component({
  selector: 'cv-page-card-holder',
  templateUrl: './page-card-holder.component.html',
  imports: [
    UICardContainerComponent,
    LocationAssetsPipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PageCardHolderComponent {

  private readonly pbes = inject(PaymentBusEventsService)
  private newRelicService = inject(NewRelicService);

  actionIsOwner(event: Event) {
    this.pbes.sendEvent({
      code: 'OPEN_GATEWAY_IZIPAY',
      description: 'DUEÑO_DE_LA_TARJETA'
    } as IEvent);

    this.newRelicService.addPageAction('BUTTON_IS_OWNER', {
      component: 'PageCardHolderComponent',
      action: 'BUTTON_IS_OWNER',
      detail: 'El usuario es dueño de la tarjeta',
      timestamp: new Date().toISOString()
    });
  }

  actionIsNotOwner(event: Event) {
    this.pbes.sendEvent({
      code: 'OPEN-INFO-BILLING',
      description: 'NO_ES_DUENO_DE_LA_TARJETA'
    } as IEvent);

    this.newRelicService.addPageAction('BUTTON_IS_NOT_OWNER', {
      component: 'PageCardHolderComponent',
      action: 'actionIsNotOwner',
      detail: 'El usuario no es dueño de la tarjeta de débito',
      timestamp: new Date().toISOString()
    });
  }
}